import type { LucideIcon } from 'lucide-react';
import { Construction } from 'lucide-react';

interface PlaceholderPageProps {
  title: string;
  description: string;
  icon?: LucideIcon;
}

export function PlaceholderPage({
  title,
  description,
  icon: Icon = Construction,
}: PlaceholderPageProps) {
  return (
    <div className="main-container-gdm flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="mb-6">
        <Icon
          className="w-16 h-16 mx-auto"
          style={{ color: 'var(--cime-gold)' }}
          aria-hidden
        />
      </div>
      <h1
        className="text-2xl font-bold text-neutral-900 mb-2"
        style={{ fontFamily: 'var(--cime-font-heading)' }}
      >
        {title}
      </h1>
      <p className="text-sm text-neutral-500 max-w-sm">{description}</p>
    </div>
  );
}
